export default __webpack_public_path__ + "static/media/reader.b6bd81c4.svg";